var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "slogan"
  }), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('a', {
    staticClass: "dl-link appstore",
    attrs: {
      "href": "https://guanwang.onelink.me/9etP/ewnca30s"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dl-link googleplay",
    attrs: {
      "href": "https://guanwanggoogleplayonly.onelink.me/RZB9/zl76j1a7"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dl-link qrcode",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('span', {
    staticClass: "qrcode-image"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })]);
}];
export { render, staticRenderFns };